import { encode as base64_encode } from "base-64";
import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import config from "../config";

class JobRequestStore {
  jobRequest = [];
  jobState = [];
  total = 0;
  loading = false;
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      jobRequest: observable,
      jobState: observable,
      total: observable,
      loading: observable,
      loadData: action,
      addData: action,
      getJobRequestData: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({
    companyId,
    departmentId,
    jobTypeId,
    jobrequestDateFrom,
    jobrequestDateTo,
    proceesed,
    finish,
    pending,
  }) {
    this.loading = true;

    var postData = {
      companyId: companyId,
      departmentId: departmentId,
      jobrequestDateFrom: jobrequestDateFrom,
      jobrequestDateTo: jobrequestDateTo,
      jobTypeId: jobTypeId,
      proceesed: proceesed,
      finish: finish,
      pending: pending,
      offset: 0,
      limit: 50,
    };
    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post(
    //     "index.php?c=jobRequest&a=getJobRequest",
    //     "postData=" + base64Input
    //   );
    // console.log("fuel detis ", response);
    const response = await postApi
      .getClient()
      .post(config.NodeUrl + "/jobRequestList/getJObRequest", postData);
    this.jobRequest = response?.data?.data?.jobRequest;
    this.jobState = response?.data?.data?.jobState;
    this.total = parseInt(response?.data?.data?.TotalCount);
    this.loading = false;
  }

  async addData(jobReqDetails) {
    var postData = jobReqDetails;
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=jobRequest&a=update", "postData=" + base64Input);

    var response = await postApi
      .getClient("")
      .post(
        config.NodeUrl + "/jobRequestList/createOrUpdateJobRequest",
        postData
      );
    return response.data;
  }

  async getJobRequestData(id) {
    var postData = { jid: id, offset: 0, limit: 1 };
    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post(
    //     "index.php?c=jobRequest&a=getJobRequest",
    //     "postData=" + base64Input
    //   );
    const response = await postApi
      .getClient("")
      .post(config.NodeUrl + "/jobRequestList/getJObRequest", postData);
    return response.data?.data?.jobRequest[0];
  }

  async deleteRecord({ companyId, Id }) {
    var postData = { tokenId: "", companyId: companyId, Id: Id };

    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=jobRequest&a=delete", "postData=" + base64Input);

    const response = await postApi
      .getClient("")
      .delete(
        `https://dolphin.trackeazy.com/api/jobRequestList/deleteJobRequest/${Id}`
      );
    return response;
  }
}

export default JobRequestStore;
